<template>
    <div>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            v-loading="isBusy"
            element-loading-spinner="el-icon-loading"
            label-width="170px"
        >
            <el-tabs v-model="activeName">
                <el-tab-pane label="Common" name="common">
                    <el-form-item label="Slug" prop="slug">
                        <el-input
                            v-model="form.slug"
                            type="text"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="Title" prop="title">
                        <el-input
                            v-model="form.title"
                            type="text"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="Logo" prop="logo">
                        <el-input
                            v-model="form.logo"
                            type="text"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="Default phone number" prop="default_phone_number">
                        <el-input
                            v-model="form.default_phone_number"
                            type="text"
                        ></el-input>
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="Styles" name="styles">
                    <styles
                        v-model="form.styles"
                        :schema="schema"
                    ></styles>
                </el-tab-pane>
            </el-tabs>
        </el-form>
        <el-button type="primary" @click="store">Save</el-button>
    </div>
</template>

<script>
  import BaseForm from '../form';
  import Styles from './styles';

  export default {
    extends: BaseForm,

    components: {
      Styles,
    },

    props: {
      schema: {
        type: Array,
        default: function () {
          return []
        },
      },
    },

    data() {
      const form = {
        slug: null,
        title: null,
        logo: null,
        styles: null,
        default_phone_number: null,
      };

      return {
        form,
        rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
        activeName: 'common',
      };
    },

    methods: {
      /**
       * @param {Object} model
       */
      initForm(model) {
        this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
      },
    },
  }
</script>

